/**
 *
 * @param {string | number} id
 * @param {string} location
 * @returns string
 */
export const suggestionStatus = (id, location = "evaluation-invendo") => {
  const strId = String(id);
  const statusMap = {
    "1": {
      "evaluation-invendo": "Dağıtıcıya Yönlendirildi",
      productization: "Ön Değerlendirme",
      otoProduct: "Çalışıyor",
    },
    "2": {
      "evaluation-invendo": "Değerlendiriciye Yönlendirildi",
      productization: "Değerlendirme",
      otoProduct: "Süreç Yönetimi Ekibine Yönlendirildi",
    },
    "3": {
      "evaluation-invendo": "Karar Vericiye Yönlendirildi",
      productization: "MvP/PoC",
      otoProduct: "MvP/PoC",
    },
    "4": {
      "evaluation-invendo": "Red Edildi",
      productization: "Kabul Edilmedi",
      otoProduct: "Kabul Edilmedi",
    },
    "5": "Invendoya Yönlendirildi",
    "6": {
      "evaluation-invendo": "Onaylandı",
      productization: "Canlı",
      otoProduct: "Canlı",
    },
    "7": "Silindi",
    "8": "Hayata Geçti",
    "9": {
      default: "Beklemede",
      otoProduct: "Ertelendi",
    },
    "10": "İptal Edildi",
  };

  const statusById = statusMap[strId];

  if (!statusById) {
    return "";
  }

  if (typeof statusById === "string") {
    return statusById;
  }

  if (strId === "9") {
    return location === "otoProduct" ? statusById.otoProduct : statusById.default;
  }

  return statusById[location] || "";
};
